<template>
    <div class="container pt-5">
        <div class="row">
            <div class="col-md-4 offset-md-4">
                <img src="../../assets/img/logo-login.svg" alt="Login" />
                <div class="panel">
                    <form @submit.prevent="login">
                        <div class="form-group">
                            <label>Personeelsnummer</label>
                            <input type="text" v-model="credentials.staff_id" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label>Wachtwoord</label>
                            <input
                                type="password"
                                v-model="credentials.password"
                                class="form-control"
                            />
                        </div>
                        <div class="d-flex">
                            <button class="btn btn--accent ml-auto" :disabled="loggingIn">
                                <i class="fa fa-spin fa-circle-o-notch mr-1" v-if="loggingIn"></i>
                                Inloggen
                            </button>
                        </div>
                    </form>
                </div>
                <div class="text-center">
                    <router-link
                        class="muted-link"
                        :to="{ name: 'forgotPassword' }"
                    >Wachtwoord vergeten</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            credentials: {
                staff_id: "",
                password: ""
            },
            loggingIn: false
        };
    },
    mounted() {},
    methods: {
        login() {
            if (this.loggingIn) {
                return;
            }

            this.loggingIn = true;

            this.$http
                .post("/auth/login", this.credentials)
                .then(res => {
                    console.log(res);
                    this.$store.commit("login", res.data);
                    this.loggingIn = false;
                    this.$router.push({ name: "home" });
                })
                .catch(err => {
                    this.$root.$emit("notify", {
                        type: "error",
                        text: "E-mailadres en / of wachtwoord klopt niet."
                    });
                    this.loggingIn = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
img {
    display: table;
    margin: 0 auto 30px;
}
.form-control {
    background-color: $subtle;
}
</style>
